import React, { useState, useRef, useEffect } from "react";

const REMINDER_OPTIONS = [
  "1 day before",
  "3 days before",
  "1 week before",
  "15 days before",
  "1 Month before"
];

export default function ReminderDropdown({ selected, onChange }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (value) => {
    onChange(value);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="ml-3">
    <div className="relative w-[199px]" ref={dropdownRef}>
      <div
        onClick={() => setOpen(!open)}
        className="h-[38px] px-4 flex items-center justify-between border border-[rgba(0,0,0,0.10)] rounded-[6px] bg-white cursor-pointer"
      >
        <span className={`text-sm font-outfit ${selected ? "text-[#18101C]" : "text-[#73607B]"}`}>
          {selected || "Choose Reminder"}
        </span>
        <img src="/chevron-down.svg" alt="▼" className="w-6 h-6 ml-2" />
      </div>

      {open && (
        <div
          className="absolute top-[39px] z-50 w-[202px] overflow-auto rounded-[9px] border border-[rgba(0,0,0,0.10)] bg-white shadow-lg"
          style={{
            boxShadow:
              "27px 46px 15px rgba(0, 0, 0, 0.00), 17px 29px 14px rgba(0, 0, 0, 0.01), 10px 16px 11px rgba(0, 0, 0, 0.05), 4px 7px 8px rgba(0, 0, 0, 0.09), 1px 2px 5px rgba(0, 0, 0, 0.10)"
          }}
        >
          {REMINDER_OPTIONS.map((option, index) => (
            <div
              key={index}
              onClick={() => handleSelect(option)}
              className="h-[30px] flex items-center px-4 cursor-pointer text-sm hover:bg-[rgba(139,85,221,0.16)] hover:border hover:border-[rgba(0,0,0,0.10)] rounded-[6px]"
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
    </div>
  );
}
